<template>
    <div class="chat-bot-wrapper">
        <div v-if="showOverlay && !showChat" class="overlay" />

        <div v-if="!showChat" class="bot-container" @click="$router.push('/chat');">
            <div class="text-bubble">Sube tus documentos y excel</div>
            <div class="bubble-chat">
                <img src="@/assets/img/chatbot/bot.png" alt="Chat Bot" />
            </div>
        </div>

        <div v-if="showChat" class="chat-box">
            <div class="chat-header">
                <button @click="toggleExpand">
                    <img src="@/assets/img/chatbot/expand.svg" alt="Expand" />
                </button>
                <span class="gradient-text">Conversación</span>
                <button @click="showChat = false">
                    <img src="@/assets/img/chatbot/exit.svg" alt="Exit" />
                </button>
            </div>

            <ChatBox :chatHistory="chatHistory" :newMessage="newMessage" @send="sendMessage"
                @update:newMessage="val => newMessage = val" :type="chatType" @file-uploaded="onFileUploaded"
                :localPdfUrl="localPdfUrl" />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import ChatBox from "@/components/Bot/ChatBox.vue";

export default {
    name: "ChatBot",
    components: { ChatBox },
    data() {
        return {
            showOverlay: true,
            showChat: false,
            thinkingMessageIndex: null
        };
    },
    computed: {
        ...mapState(["chatHistory", "newMessage", "localPdfUrl"]),
        ...mapGetters(["chatType"]),
        pdfUrl() {
            if (this.localPdfUrl) return this.localPdfUrl;
            const fileMessage = this.chatHistory.find(
                msg => msg.type === "file" && msg.name.endsWith(".pdf")
            );
            return fileMessage ? `/pdfs/${encodeURIComponent(fileMessage.name)}` : null;
        },
        pdfUrlWithViewer() {
            if (this.localPdfUrl) return this.localPdfUrl;
            return `https://docs.google.com/gview?url=${encodeURIComponent(window.location.origin + this.pdfUrl)}&embedded=true`;
        }
    },
    methods: {
        ...mapMutations({
            setPdfUrl: "SET_PDF_URL"
        }),
        ...mapActions([
            "addMessage",
            "updateMessage",
            "resetChat",
            "changeChatType"
        ]),

        toggleExpand() {
            this.$router.push('/chat');
        },

        async sendMessage(question) {
            if (!question?.trim()) return;

            await this.addMessage({ from: "me", type: "text", text: question });
            await this.updateMessage("");
            await this.addMessage({ from: "bot", type: "text", text: "Pensando", thinking: true });

            this.thinkingMessageIndex = this.chatHistory.length - 1;

            try {
                const response = await this.$axios.post(
                    "https://api-qa.chelita.com.mx/pdf-agent/ask",
                    { user_id: "123", question },
                    { headers: { "Content-Type": "application/json" } }
                );

                this.$store.commit("ADD_MESSAGE", {
                    from: "bot",
                    type: "html",
                    text: response.data.answer
                });

                this.$store.state.chatHistory.splice(this.thinkingMessageIndex, 1);
            } catch (error) {
                console.error("Error al enviar pregunta:", error);
                this.$store.state.chatHistory.splice(this.thinkingMessageIndex, 1, {
                    from: "bot",
                    type: "text",
                    text: "Ocurrió un error al procesar tu pregunta. Intenta nuevamente."
                });
            }

            this.thinkingMessageIndex = null;
        },

        async onFileUploaded(file) {
            const blobUrl = URL.createObjectURL(file);
            this.setPdfUrl(blobUrl);

            await this.addMessage({
                from: "me",
                type: "file",
                name: file.name,
                text: "Archivo cargado correctamente.",
                icon: require("@/assets/img/chatbot/pdf-icon.svg")
            });

            await this.addMessage({
                from: "bot",
                type: "text",
                text: "Pensando",
                thinking: true
            });

            this.thinkingMessageIndex = this.chatHistory.length - 1;

            try {
                const formData = new FormData();
                formData.append("user_id", "123");
                formData.append("file", file);

                await this.$axios.post(
                    "https://api-qa.chelita.com.mx/pdf-agent/upload-pdf",
                    formData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );

                this.$store.state.chatHistory.splice(this.thinkingMessageIndex, 1, {
                    from: "bot",
                    type: "text",
                    text: "El archivo fue subido correctamente al servidor."
                });
            } catch (error) {
                console.error("Error al subir el archivo:", error);

                this.$store.state.chatHistory.splice(this.thinkingMessageIndex, 1, {
                    from: "bot",
                    type: "text",
                    text: "Hubo un error al subir el archivo. Intenta nuevamente."
                });
            }

            this.thinkingMessageIndex = null;
        }
    },
    mounted() {
        setTimeout(() => {
            this.showOverlay = false;
        }, 5000);

        this.changeChatType('file');
    }
};
</script>


<style scoped>
.chat-bot-wrapper {
    position: fixed;
    bottom: 100px;
    right: 50px;
    z-index: 10;
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 9;
}


.bot-container {
    position: fixed;
    bottom: 100px;
    right: 50px;
    display: flex;
    align-items: center;
    gap: 16px;
    z-index: 10;
    cursor: pointer;
}

.text-bubble {
    position: relative;
    padding: 12px 20px;
    border-radius: 32px;
    background-color: #00344D;
    color: white;
    font-weight: 600;
    font-size: 16px;
}

.text-bubble::before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border-radius: 32px;
    background: linear-gradient(180deg,
            #1499FC 0%,
            #50CEF5 44.71%,
            #1499FC 69.23%,
            #50CEF5 97.12%);
    z-index: -1;
    box-shadow: 0 0 8px #2489ca, 0 0 16px #2489ca;
}


.bubble-chat {
    position: relative;
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background-color: #00344D;
    display: flex;
    align-items: center;
    justify-content: center;
}

.bubble-chat::before {
    content: '';
    position: absolute;
    top: -4px;
    left: -4px;
    right: -4px;
    bottom: -4px;
    border-radius: 50%;
    background: linear-gradient(180deg,
            #1499FC 0%,
            #50CEF5 44.71%,
            #1499FC 69.23%,
            #50CEF5 97.12%);
    z-index: -1;
    box-shadow: 0 0 10px #2489ca, 0 0 20px #2489ca, 0 0 30px #2489ca;
}

.bubble-chat img {
    width: 40px;
    height: 40px;
}

.chat-box {
    width: 400px;
    height: 520px;
    background-color: #061821;
    border-radius: 16px;
    box-shadow: 0 0 20px #2489ca;
    display: flex;
    z-index: 9999;
    flex-direction: column;
    overflow: hidden;
}

.chat-header {
    margin: 25px 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    text-align: center;
    background-color: #061821;
    align-items: center;
}

.chat-header button {
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
}


.chat-header .icons button {
    background: none;
    border: none;
}


.gradient-text {
    color: #47A4D0;
    background: linear-gradient(180deg, #47A4D0 0%, #014E72 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-block;
    font-weight: 400;
    font-size: 16px;
}


@media (max-width: 768px) {

    .bot-container {
        bottom: 20px;
        right: 20px;
    }

    .chat-bot-wrapper {
        position: fixed;
        bottom: 5vh;
        right: 10px;
        z-index: 10;
    }

    .chat-box {
        width: 90dvw;
        height: 75vh;
        max-width: 100vw;
    }

}
</style>